import { useMemo } from 'react'
import { LOYALTY_CAMPAIGN_OFFERS, LoyaltyCampaignOffer } from 'loyalty/constants/loyaltyCampaignOffers'
import useLoyaltyActiveCustomRules from './useLoyaltyActiveCustomRules'
import { useAppSelector } from 'hooks/reduxHooks'

/**
 * Returns the list of enabled loyalty campaign offers
 * Filters based on:
 * 1. regions - if specified, only shows in those regions
 * 2. forceEnable: true - always shows (this is for offers not relied custom rules)
 * 3. customRuleId - shows only when rule is active
 */
function useLoyaltyCampaignOffers(): Array<LoyaltyCampaignOffer> {
  const activeRuleIds = useLoyaltyActiveCustomRules()
  const currentRegion = useAppSelector(state => state.geo.currentRegionCode)

  return useMemo(() => {
    return LOYALTY_CAMPAIGN_OFFERS.filter(offer => {
      if (offer.regions && !offer.regions.includes(currentRegion)) {
        return false
      }

      // If forceEnable is true, always show
      if ('forceEnable' in offer && offer.forceEnable) {
        return true
      }

      if ('customRuleIds' in offer) {
        return offer.customRuleIds.some(ruleId => activeRuleIds.has(ruleId))
      }

      return false
    })
  }, [activeRuleIds, currentRegion])
}

export default useLoyaltyCampaignOffers
